import React, { useState, useEffect } from 'react';
import { versionService } from '../services/versionService';
import './UpdateNotification.css';

const UpdateNotification = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [newVersion, setNewVersion] = useState('');

  // Clé pour localStorage - version déjà notifiée
  const NOTIFIED_VERSION_KEY = 'horae_notified_version';

  // Vérifier si une version a déjà été notifiée
  const isVersionAlreadyNotified = (version) => {
    const notifiedVersion = localStorage.getItem(NOTIFIED_VERSION_KEY);
    return notifiedVersion === version;
  };

  // Marquer une version comme notifiée
  const markVersionAsNotified = (version) => {
    localStorage.setItem(NOTIFIED_VERSION_KEY, version);
  };

  useEffect(() => {
    // S'abonner aux notifications de mise à jour
    const handleUpdateAvailable = (version, force) => {
      // Ne pas afficher si la version a déjà été notifiée
      if (isVersionAlreadyNotified(version)) {
        return;
      }
      
      setNewVersion(version);
      setShowNotification(true);
    };

    versionService.onUpdateAvailable(handleUpdateAvailable);

    // Vérifier l'état actuel au montage
    const status = versionService.getStatus();
    if (status.updateAvailable && !isVersionAlreadyNotified(status.currentVersion)) {
      setShowNotification(true);
    }

    return () => {
      // Nettoyage lors du démontage
    };
  }, []);

  const handleAcknowledged = () => {
    // Marquer cette version comme notifiée
    markVersionAsNotified(newVersion);
    setShowNotification(false);
  };

  if (!showNotification) {
    return null;
  }

  return (
    <div className="update-notification-overlay">
      <div className="update-notification">
        <div className="update-notification-header">
          <div className="update-notification-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
          </div>
          <h3>Nouvelle version disponible</h3>
        </div>
        
        <div className="update-notification-content">
          <p>
            Une nouvelle version de l'application est disponible 
            {newVersion && ` (v${newVersion})`}.
          </p>
          
          <p>
            <strong>Pour bénéficier des dernières améliorations :</strong>
          </p>
          
          <ul>
            <li>Fermez complètement l'application</li>
            <li>Réouvrez-la depuis l'icône sur votre écran d'accueil</li>
          </ul>
          
          <p>
            <em>Cette mise à jour apporte des améliorations et des corrections.</em>
          </p>
        </div>

        <div className="update-notification-actions">
          <button 
            className="update-notification-button update-notification-button-primary"
            onClick={handleAcknowledged}
          >
            C'est noté
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification; 